<template>
  <Flex justify="between">
    <Flex direction="column">
      <BaseText>
        {{ $t('subscription.cancelation_flow.contact_message.description') }}
      </BaseText>
      <BaseText>
        {{ $t('subscription.cancelation_flow.contact_message.contact_details_heading') }}
      </BaseText>
      <div :class="$style.contactInfo">
        <BaseText
          iconBefore="email"
          v-test="'cancel-subscription-contact-email'"
        >
          {{ company.contactEmail }}
        </BaseText>
        <BaseText
          iconBefore="phone"
          v-test="'cancel-subscription-contact-phone'"
        >
          {{ company.phone }}
        </BaseText>
      </div>
      <BaseAlert
        color="warning"
        :text="$t('subscription.cancelation_flow.contact_message.contact_details_warning')"
      />
    </Flex>
    <img
      v-if="$screen !== 's'"
      src="/img/cancel-subscription/person-asking-why.svg"
      :class="$style.image"
    >
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { useCompanyStore } from '@/stores/company';

const { company } = useCompanyStore();
</script>

<style
  lang="scss"
  module
>
.image {
  height: 170px;
  width: auto;
}
</style>
